<div class="language-wrapper" [ngClass]="{'language-wrapper--shrink': isShrink}">
  <ms-language-picker></ms-language-picker>
  @if (winterSeason()) {
    <div
      (click)="changeWinterMode()"
      class="winter-btn"
      [ngClass]="{'disabled': !statusWinterMode()}"
      [matTooltip]="statusWinterMode() ? ('v3.setting.snowfall.off' | translate) : ('v3.setting.snowfall.on' | translate)"
      matTooltipPosition="right"
    >
      <i class="fas fa-snowflake"></i>
    </div>
  }
</div>

<ms-subscription-status [color]="color"></ms-subscription-status>

<hr class="delimiter">

<div class="profile-container">
  <a routerLink="/profile" class="profile-link">
    <div
      class="photo"
      style="background-image: url('{{ user?.photo | imageStorage : true }}')"
    ></div>

    <div *ngIf="!isShrink" class="personal-info">
      <div class="full-name">
        {{ user?.user?.firstName + ' ' + user?.user?.lastName }}
      </div>
      <div class="email">
        {{ user?.user?.email }}
      </div>
    </div>
  </a>

  <button class="logout" aria-label="logout" (click)="logOut()">
    <span class="logout-icon msi-logout"></span>
  </button>
</div>
